import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { ApiQueryParams } from 'types/ApiQueryParams';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetPartnerSharesProps = {
  partnerId: string;
  params?: ApiQueryParams;
  signal?: AbortSignal;
};

export const getPartnerShares =
  ({ partnerId, params, signal }: GetPartnerSharesProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.get('/partners/shares', {
        params: { partnerId, ...params },
        // signal
      });

      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
